//src/redux/constants/authKeys.js
export const ADMIN_TOKEN_KEY = 'adminToken';
export const ADMIN_USER_KEY  = 'adminUser';
export const ADMIN_GUARD_KEY = 'adminGuard';
